export default __webpack_public_path__ + "static/lozenge-dropdown-dont-2-light-8ffbc89fb615b5f60b96c37b05ccebd2.png";